"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const ClientRequest_1 = __importDefault(require("../ClientRequest"));
const Url_1 = __importDefault(require("../Url"));
const UserApi = {
    retrieveUser: async () => {
        const res = await ClientRequest_1.default.get('users/me');
        return res;
    },
    initialSetup: async (data) => {
        const res = await ClientRequest_1.default.post('users/me/setup', data);
        return res.data;
    },
    getUserRetrievalArticles: async (contentType, page) => {
        const res = await ClientRequest_1.default.get(`users/me/articles?content_type=${contentType}&page=${page}&per_page=8`);
        return res.data;
    },
    searchVideo: async (data) => {
        const res = await ClientRequest_1.default.get(`videos/search?${data}`);
        return res;
    },
    detailVideo: async (data) => {
        const res = await ClientRequest_1.default.get(`videos/${data}`);
        return res.data;
    },
    comments: async (data) => {
        const res = await ClientRequest_1.default.post(`videos/${data.video_id}/comments`, {
            comment: data.comment,
        });
        return res;
    },
    unitList: async (data) => {
        const res = await ClientRequest_1.default.get(`units${data}`);
        return res.data;
    },
    CountView: async (data) => {
        const res = await ClientRequest_1.default.post(`videos/${data.video_id}/views`, {});
        return res;
    },
    contact: async (data) => {
        const res = await ClientRequest_1.default.post(`inquiries`, {
            name: data.name,
            email: data.mail,
            content: data.contentContact,
        });
        return res;
    },
    getTokenFirebaseAuthToken: async () => {
        const res = await ClientRequest_1.default.get(Url_1.default.firebaseAuthToken);
        return res;
    },
    getUserDetailDashboard: async (userHandle) => {
        const res = await ClientRequest_1.default.get(`users/${userHandle}`);
        return res.data;
    },
    getUserDetailArticles: async (userId, contentType, page) => {
        const res = await ClientRequest_1.default.get(`users/${userId}/articles?content_type=${contentType}&page=${page}&per_page=8`);
        return res.data;
    },
    updateUserIndividualNotificationSetting: async (userId, data) => {
        const res = await ClientRequest_1.default.patch(`users/${userId}/notification-setting`, data);
        return res.data;
    },
    updateProfile: async (data) => {
        const res = await ClientRequest_1.default.post('users/me', data, {
            timeout: constants_1.UPLOAD_VIDEO_INTRO_TIMEOUT,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res?.data;
    },
    withdrawalAcc: async (reason) => {
        const res = await ClientRequest_1.default.delete(`users/withdrawal`, {
            data: {
                delete_reason: reason,
            },
        });
        return res.data;
    },
    pushNotiSetting: async (data) => {
        const res = await ClientRequest_1.default.patch(`push-notification-setting`, data);
        return res.data;
    },
    boxNotiSetting: async (data) => {
        const res = await ClientRequest_1.default.patch(`box-notification-setting`, data);
        return res.data;
    },
    hashtagSearch: async (data) => {
        const res = await ClientRequest_1.default.get(`hash-tags?page=${data.page}&type=${data.type}`);
        return res.data;
    },
    changePassword: async (data) => {
        const URL = '/change-password';
        const res = await ClientRequest_1.default.put(URL, data);
        return res.data;
    },
    searchUser: async (search, page) => {
        const res = await ClientRequest_1.default.get(`users/search?page=${page}&name=${search}`);
        return res.data;
    },
    getBlockUserList: async (params) => {
        const res = await ClientRequest_1.default.get('/blocks', {
            params: params,
        });
        return res.data;
    },
    getMuteUserList: async (params) => {
        const res = await ClientRequest_1.default.get('/user-mutes', {
            params: params,
        });
        return res.data;
    },
    getPersonalInformation: async () => {
        const res = await ClientRequest_1.default.get('users/personal-information');
        return res.data;
    },
    authnSMS: async (firebase_token) => {
        const res = await ClientRequest_1.default.patch('users/sms-authn', { firebase_token });
        return res.data;
    },
    updateBirthday: async (date_of_birth) => {
        const res = await ClientRequest_1.default.patch('users/birthday', { date_of_birth });
        return res.data;
    },
    repostArticle: async (data) => {
        const res = await ClientRequest_1.default.post(`articles/${data?.id}/reports`, data?.formdata, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res?.data;
    },
    repostArticleComment: async (data) => {
        const res = await ClientRequest_1.default.post(`article-comments/${data?.id}/reports`, data?.formdata, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res?.data;
    },
    repostTweet: async (data) => {
        const res = await ClientRequest_1.default.post(`tweets/${data?.id}/reports`, data?.formdata, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res?.data;
    },
    repostUser: async (data) => {
        const res = await ClientRequest_1.default.post(`users/${data?.id}/reports`, data?.formdata, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res?.data;
    },
};
exports.default = UserApi;
